import React from 'react';
import SubMenuButton from './SubMenuButton.jsx';
import styles from './SubMenu.module.css';

// Create a modal backdrop component specifically for the submenu
const SubMenuBackdrop = ({ isVisible }) => {
    if (!isVisible) return null;

    return (
        <div className={styles.submenuBackdrop} />
    );
};

const SubMenu = ({ activePage, setActivePage, campaignPromiseType, subMenuConditions }) => {
    // Check if there's a modal open
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    React.useEffect(() => {
        // check if modal is open
        const checkModalState = () => {
            setIsModalOpen(document.body.classList.contains('modalOpen'));
        };

        checkModalState();

        // Set up a MutationObserver to watch for body class changes
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    checkModalState();
                }
            });
        });

        observer.observe(document.body, { attributes: true });

        return () => observer.disconnect();
    }, []);

    return (
        <div className={styles.submenu}>
            {/* Add the backdrop when modal is open */}
            <SubMenuBackdrop isVisible={isModalOpen} />

            <ul className={isModalOpen ? styles.disabledMenu : ''}>
                <SubMenuButton
                    label="Summary"
                    isActive={activePage === 'Summary'}
                    onClick={() => setActivePage('Summary')}
                    disabled={isModalOpen}
                />
                {subMenuConditions.DetailsEnabled &&
                    <SubMenuButton
                        label="Details"
                        isActive={activePage === 'Details'}
                        onClick={() => setActivePage('Details')}
                        disabled={isModalOpen}
                    />
                }
                {subMenuConditions.PicturesEnabled &&
                    <SubMenuButton
                        label="Pictures"
                        isActive={activePage === 'Pictures'}
                        onClick={() => setActivePage('Pictures')}
                        disabled={isModalOpen}
                    />
                }
                {subMenuConditions.CampaignExperienceEnabled &&
                    <SubMenuButton
                        label="Campaign Experience"
                        isActive={activePage === 'CampaignExperience'}
                        onClick={() => setActivePage('CampaignExperience')}
                        disabled={isModalOpen}
                    />
                }
                <SubMenuButton
                    label="Map"
                    isActive={activePage === 'Map'}
                    onClick={() => setActivePage('Map')}
                    disabled={isModalOpen}
                />
                <SubMenuButton
                    label="Address list"
                    isActive={activePage === 'AddressList'}
                    onClick={() => setActivePage('AddressList')}
                    disabled={isModalOpen}
                />
                {subMenuConditions.OIEnabled &&
                    <SubMenuButton
                        label="Outdoor Impact"
                        isActive={activePage === 'OutdoorImpact'}
                        onClick={() => setActivePage('OutdoorImpact')}
                        disabled={isModalOpen}
                    />
                }
                {subMenuConditions.EffectMeasureEnabled && 
                    <SubMenuButton
                        label="Campaign effect measure"
                        isActive={activePage === 'EffectMeasure'}
                        onClick={() => setActivePage('EffectMeasure')}
                        disabled={isModalOpen}
                    />
                }
            </ul>
        </div>
    );
};

export default SubMenu;